import { render, staticRenderFns } from "./Oldcompetitions.vue?vue&type=template&id=0bfbbd16&scoped=true"
import script from "./Oldcompetitions.vue?vue&type=script&lang=js"
export * from "./Oldcompetitions.vue?vue&type=script&lang=js"
import style0 from "./Oldcompetitions.vue?vue&type=style&index=0&id=0bfbbd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfbbd16",
  null
  
)

export default component.exports